<template>
    <div id="pumptankmapperlist">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Fuel Tank Pump Mapper List</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="btn-groups text-right">
                        <router-link v-if="canAddMod" class="btn btn-primary" v-bind:to="{name: 'FuelPumpMapper'}" > <i class="fp-add"> </i> Add</router-link>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content customer-detail">
                        <data-table-filter-config :moduleName="'tankPumpMapperList'" ref="filtertankPumpMapperList" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'tankPumpMapperList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="tankPumpMapperTable"
                                    mode="remote"
                                    title="FuelPrice"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    @on-select-all="onSelectAll"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: fuelmode_value,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <router-link title="Edit Fuel Pump Mapper" v-if="canUpdateMod == true" class="fp-edit" v-bind:to="{name: 'FuelPumpMapperEdit',params:{id:props.row.id}}"></router-link>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>
                                    <div slot="selected-row-actions">
                                        <button v-if="fuelmode_value" id="deleteVehicleModelBtn" v-on:click.prevent="fuelPumpMappingDelete" class="btn btn-primary">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";
import EventBus from "./event-bus";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "TankPumpMapperList",
        metaInfo() {
            return {title: "Fuel Tank Pump Mapper List | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            userColumns:[],
            cantAccessPage: "",
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: 'Location',
                    field: 'location',
                    fpFieldType:"option",
                    filterable: true,
                },
                {
                    label: 'Pump#',
                    field: 'pump_no',
                    fpFieldType:"integer",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Tank#',
                    field: 'tank_no',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        filterDropdownItems: ['Diesel Tank 1','DEF Tank 2'],
                    },
                },
                {
                    label: 'Added By',
                    field: 'created_by',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                },
                
            ],
            rows: [],
            totalRecords: 0,
            fuelmode_value: false,
            loading:false,
            canAddMod:false,
            canUpdateMod:false,
            action:'list',
            endShift:false,
            reading_identifier:'',
            userRole:'',
            pageKey:"_fuel_tank_pump_list_",
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_fuel_ticket') {
                            self.cantAccessPage = true;
                        }
                      
                        if (permissions[i].name == 'add_fuel_ticket') {
                            self.canAddMod = true;
                            self.canUpdateMod = true;
                            self.fuelmode_value = true;
                        }
                    }
                }

            }
        },
        created: function() {

        },
        mounted: function() {
            var self = this;
            //self.loadList();
            self.getPermissions();

            var userObj = JSON.parse(localStorage.getItem("user_obj"));

            if (userObj != null) {
                if (userObj.roles.length > 0) {
                    self.userRole = userObj.roles[0].name;
                }

            }
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.filtertankPumpMapperList.unselectAllInternal();
            },
            
            selectionChanged(param) {
                var self = this;
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
                self.serverParams.selectedAll = false;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
            },
          
            loadList() {
                var data = this.$refs['tankPumpMapperTable'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['tankPumpMapperTable'].selectedRows[i].id)
                }
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    action:self.action,
                    all:self.serverParams.selectedAll,
                    id:use
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/fuel-tank-pump-mapper/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            if (self.action == 'delete'){
                                self.action = 'list';
                                self.$refs.filtertankPumpMapperList.clearSelectAll();
                                EventBus.$emit('clear-all-flags', false);
                                self.loadList();
                            }else{
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                            }
                            self.filteredFlag = false;
                        }

                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'load-asset-model-list')
                    }
                });
            },
            fuelPumpMappingDelete() {
                var data = this.$refs['tankPumpMapperTable'].selectedRows;
                var self = this;
                // var use = [];
                // for (var i = 0; i < data.length; i++) {
                //     use.push(this.$refs['tankPumpMapperTable'].selectedRows[i].id)
                // }
                self.$swal({
                    title: 'Are you sure that you want to delete this Mapping?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                      self.action = 'delete';
                      self.loadList();

                    } else {
                      console.log("no");
                    }
                });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/FuelTankPumpMapperList.vue